/** Broadcast when a species mutation catalog changes so bird/pair UIs can reload. */
export const GENETICS_CATALOG_CHANGED_EVENT = 'birdman:genetics-catalog-changed';

export function notifyGeneticsCatalogChanged(speciesId: string) {
  if (typeof window === 'undefined' || !speciesId) return;
  window.dispatchEvent(
    new CustomEvent(GENETICS_CATALOG_CHANGED_EVENT, {
      detail: { speciesId, at: Date.now() },
    }),
  );
}

export function subscribeGeneticsCatalogChanged(
  speciesId: string | undefined,
  onChange: () => void,
): () => void {
  if (typeof window === 'undefined' || !speciesId) return () => undefined;
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<{ speciesId?: string }>).detail;
    if (detail?.speciesId === speciesId) onChange();
  };
  window.addEventListener(GENETICS_CATALOG_CHANGED_EVENT, handler);
  return () => window.removeEventListener(GENETICS_CATALOG_CHANGED_EVENT, handler);
}
